import Col from "components/ui-elements/Col";
import React from "react";
import Dropdown from "./Dropdown";
const DropdownCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <Dropdown {...rest} />
    </Col>
  );
};

DropdownCol.defaultProps = {
  colsize: 12,
  model: "md",
  margin: "mb-1"
}

export default DropdownCol;